import { render, staticRenderFns } from "./LieuxExercice.vue?vue&type=template&id=00722815"
import script from "./LieuxExercice.vue?vue&type=script&lang=js"
export * from "./LieuxExercice.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports